import { useEffect, useState } from "react";
import { listAction as productListAction} from "../../../network/store/action/ProductResponseAction";
import { consoleLog } from "../../../utils/log-utils";
import AppPagination from "../../../components/pagination";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_CONFIG, API_HEADERS } from "../../../network/config/ApiConfig";
import { axiosApi } from "../../../network/service/config/AaxiosUtil";
import { updateMessage } from "../../../redux/slice/toastSlice";
import { MdOutlinePriceChange } from "react-icons/md";

function UniqueStoreProductAdding(){

  const location=useLocation();
  const categoryId=location.state.categoryId;
  const subCategoryId=location.state.subCategoryId;
  const storeId=location.state.storeId;
  const [productList,setProductList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(20);
  const [pageOffset, setPageOffset] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [productStatus,setProductStatus]=useState(false);
  const [productRefresh,setProductRefresh]=useState(false)
  const dispatch=useDispatch();
  const navigate=useNavigate();

  useEffect(() => {
      getProducts(
        pageLimit,
        pageOffset,
       
        subCategoryId
      );
      // getProducts();
    }, [productRefresh,pageLimit,activePage,totalCount]);
  
  // useEffect(()=>{
  //   getProducts();
  // },[productRefresh])
    const getProducts = async (
        pageLimit,
        pageOffset,
        
        subCategoryId,
       
      ) => {
        // await dispatch(

        //   productListAction(
        //     {
        //       limit:pageLimit,
        //       offset:pageOffset,
        //       categoryId: subCategoryId,
        //       storeId: storeId,
              
        //     },
        //     dispatch
        //   )
        // ).then((response) => {
        //   if (response.result) {
        //     consoleLog("response", response);
        //     setProductList(response.result)
        //     setTotalCount(Number(response.itemCount.totalFilterCount));
        //     setPageCount(response.itemCount.pageCount);
        //     // if (productAddForm.searchProduct !== "") {
        //     //   ProductSearch(reponse.result);
        //     // } else {
    
        //     // }
            
        //   } else {
        //   }
        // });

        let data= await axios.get(`${API_CONFIG.API_HOST}Product/storeProducts?storeId=${storeId}&categoryId=${subCategoryId}&limit=${pageLimit}&offset=${pageOffset}`,{
              headers:API_HEADERS
            })
            if(data.data.result){
              consoleLog("response", data.data);
                  setProductList(data.data.result)
                  // setTotalCount(Number(response.itemCount.totalFilterCount));
                  // setPageCount(response.itemCount.pageCount);
                  // if (productAddForm.searchProduct !== "") {
                  //   ProductSearch(reponse.result);
                  // } else {}
            }

      };
     
    //  const getProducts=async()=>{
    //   let data= await axios.get(`https://api.eatprotein.in/Product/storeProducts?storeId=${storeId}&categoryId=${subCategoryId}`,{
    //     headers:API_HEADERS
    //   })
    //   setProductList(data.data.result)
    //  }

      const handlePageChange = (selectedPage) => {
        setActivePage(selectedPage);
        setPageOffset((selectedPage - 1) * pageLimit);
      };

      const onStatusChange = async (product) => {
          let changingStatus = "YES";
          setProductStatus(product.storeProductStatus)
          if (product.storeProductStatus == "NO") {
            changingStatus = "YES";
          } else {
            changingStatus = "NO";
          }

          let requestBody=null;
      
          if(product.storeProductId !=="NO"){
            requestBody = {
              storeId:storeId,
              status: changingStatus,
              productId:product.id,
              categoryId:product.subcategory_id,
              id:product.storeProductId
            };
          }
          else{
            requestBody = {
              storeId:storeId,
              productId:product.id,
              status: changingStatus,
              categoryId:product.subcategory_id,
            };
          }
          
      
          await axiosApi
            .post(API_CONFIG.API_HOST +"Product/updateStoreProduct" , requestBody, {
              API_HEADERS,
            })
            .then((response) => {
              consoleLog("STORE category UPODATE", response);
              if (response.status === 200 && response.data.status === true) {
                // setItem(product, (product.status = changingStatus));
                setProductStatus(changingStatus);
                setProductRefresh(productRefresh=>!productRefresh)
              } else {
                dispatch(
                  updateMessage({
                    display: true,
                    message: "Error While updating info",
                  })
                );
              }
            });
        };

      const handleLimitChange = (e) => {
        setPageLimit(e.target.value);
        setPageOffset(0);
        setActivePage(1);
      };

return(
   
    <>

<h5 className="mt-4" style={{textAlign:"center"}}>Products</h5>
     <div className="col-md-12 card-1 h-scroll mt-3">

        
              
              <div className="m-3">
               
                <table className="table table-hover align-middle">
                  <thead className="thead-dark">
                    <tr id="Row1">
                      <th Scope="col-1">Name</th>
                      <th scope="col-1">Status</th>
                      <th scope="col-1">Pricing</th>
                    </tr>
                  </thead>

                  <tbody>
                    {
                      productList && productList.length > 0 && productList.map((obj, sno) => {
                        return (
                          <tr id={obj.id}>
                            {/* <td>
                              <img
                                src={getImagePath(obj.image_path)}
                                // alt={obj.name}
                                className="img-thumbnail"
                                width="50px"
                                height="50px"
                              />
                            </td> */}
                            <td>{obj.product_name}</td>
                            <td>
                              <div className="form-check form-switch d-flex flex-row justify-content-center">

                                <input type="checkbox"
                                  className="form-check-input"
                                  onChange={()=>{onStatusChange(obj);
                                    setProductStatus(productStatus=>!productStatus)
                                  }}
                                  checked={obj.storeProductStatus === "YES" ? true : false}
                                  role="switch"
                                />
                              </div>

                            </td>
                            <td onClick={()=>navigate("/productPricingList",{state:{productId:obj.id,productStoreId:storeId}})}>
                              
                              <MdOutlinePriceChange/>
                            </td>
                          </tr>
                        )
                      })
                    }
                  </tbody>

                </table>
                <AppPagination
              pageCount={pageCount}
              activePage={activePage}
              totalCount={totalCount}
              onPageChange={(page) => handlePageChange(page)}
              onLimitChange={(e) => handleLimitChange(e)}
            />
              </div>

            </div>
    </>
)
}
export default UniqueStoreProductAdding;